<template>
  <div>
    <v-container fluid>
      <v-row>
        <v-col lg="12">
          <v-card class="card--shadow">
            <list :homeVisitData="homeVisitData" :isUncompleted="true" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import List from "@/components/home-visit/List";
import { mapState } from "vuex";

export default {
  components: {
    List,
  },
  computed: {
    ...mapState("HomeVisit", ["homeVisitData"]),
  },
  methods: {},
  created() {
    this.$store.dispatch("HomeVisit/getUncompletedList", {
      ids: JSON.parse(this.$route.query.values),
    });
  },
};
</script>
